import { Flex, Link, Text } from '@chakra-ui/react';
import { ReactComponent as CrownIcon } from 'assets/icons/crown_upgrade_fill.svg';
import { UserTypes } from 'modules/User';

import { OptionTitleProps, UpgradeLockProps } from './DownloadModal.types';

export const OptionTitle = ({
  children,
  upgradeDescription,
  shouldUpgrade,
  handleClickUpgrade,
  postText,
  userType,
}: OptionTitleProps) => {
  return (
    <Flex alignItems={'center'} p='2' pl='0'>
      <Text fontSize='sm' fontWeight='semibold' mr='2'>
        {children}
      </Text>
      {shouldUpgrade && (
        <UpgradeLock
          handleClickUpgrade={handleClickUpgrade}
          upgradeText={upgradeDescription}
          postText={postText}
          userType={userType}
        />
      )}
    </Flex>
  );
};

export const UpgradeLock = ({ handleClickUpgrade, upgradeText, postText, userType }: UpgradeLockProps) => {
  const lockDownloadTestId = 'lock-download-icon';

  return (
    <Flex flexDir='row'>
      <CrownIcon
        color={userType === UserTypes.Free ? 'var(--vg-colors-avatar-3)' : 'var(--vg-colors-upgrade-blue-500)'}
        data-testid={lockDownloadTestId}
      />
      <Link
        fontSize='sm'
        color={userType === UserTypes.Free ? 'avatar.3' : 'upgrade.blue.500'}
        fontWeight='semibold'
        ml='1'
        lineHeight='1.2'
        onClick={handleClickUpgrade}
        as='button'
      >
        {upgradeText}
      </Link>
      {postText && (
        <Text fontSize='sm' fontWeight='semibold' ml='1' lineHeight='1.2'>
          {postText}
        </Text>
      )}
    </Flex>
  );
};
